import {
    CLOUDLOGINPAGE_UPLOAD_IMAGE_OPEN_MODAL,
    CLOUDLOGINPAGE_UPLOAD_IMAGE_REQUEST,
    CLOUDLOGINPAGE_UPLOAD_IMAGE_RESULT,
    CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_REQUEST,
    CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    imageList: [],
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CLOUDLOGINPAGE_UPLOAD_IMAGE_OPEN_MODAL:
            return { ...state, openModal: action.payload }

        case CLOUDLOGINPAGE_UPLOAD_IMAGE_REQUEST:
            return { ...state, loading: true }

        case CLOUDLOGINPAGE_UPLOAD_IMAGE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_REQUEST:
            return { ...state, loading: true }

        case CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_RESULT:
            return { ...state, loading: false, imageList: action.payload }

        case CLEAR_REDUX:
            return ["", "CLOUDLOGINPAGE_UPLOAD_IMAGE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};